import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export default function RemoveEphemeralNodeDialog({ open, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='remove-ephemeral-node-dialog-title'
      aria-describedby='remove-ephemeral-node-dialog-description'
    >
      <DialogTitle id='remove-ephemeral-node-dialog-title'>
        Remove Ephemeral Node
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='remove-ephemeral-node-dialog-description'>
          Ephemeral nodes are tied to jobs, if you remove the ephemeral node, it
          will terminate the associated job. Remove the associated job from the
          job dashboard to remove the node instead. Only proceed if the job is
          already unused.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={onConfirm} color='error' variant='contained'>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
